import React from 'react'
import { useParams, Link as RouterLink } from 'react-router-dom'

import { Box, Link, Typography } from '@mui/material'

import LoadingSpinner from '../LoadingSpinner'
import NotFound from '../NotFound'
import Markdown from './Markdown'
import { fetchArticle, formatArticleDate } from './articleRequest'

// One article of a collection (`/news/:slug`), from the Markdown file Rails
// serves at `/<collection>/<slug>.json`. Help pages don't show their date
// (`showDate`).
export default function Article({ collection, collectionTitle, showDate = true }) {
  const { slug } = useParams()
  const [result, setResult] = React.useState(null)

  React.useEffect(() => {
    let current = true
    setResult(null)
    fetchArticle(`/${collection}/${slug}`).then((fetched) => {
      if (current) setResult(fetched)
    })
    return () => { current = false }
  }, [collection, slug])

  React.useEffect(() => {
    if (result?.json) document.title = `${result.json.title} - Stikis`
  }, [result])

  const backLink = (
    <Typography variant='body2' sx={{ mt: 4 }}>
      <Link component={RouterLink} to={`/${collection}`}>
        All {collectionTitle.toLowerCase()}
      </Link>
    </Typography>
  )

  if (!result) return <LoadingSpinner />

  if (result.notFound) return <NotFound>{backLink}</NotFound>

  if (!result.json) {
    return (
      <Box component='article' sx={{ width: '100%', maxWidth: 700 }}>
        <Typography component='h1' variant='h4' gutterBottom>
          This page could not be loaded
        </Typography>
        <Typography variant='body1'>
          Please try again in a moment.
        </Typography>
        {backLink}
      </Box>
    )
  }

  const article = result.json
  return (
    <Box component='article' sx={{ width: '100%', maxWidth: 700 }}>
      <Typography component='h1' variant='h4' gutterBottom={!showDate}>
        {article.title}
      </Typography>
      {showDate && (
        <Typography variant='body2' color='text.secondary' sx={{ mb: 3 }}>
          {formatArticleDate(article.date)}
        </Typography>
      )}
      <Markdown>{article.body}</Markdown>
      {backLink}
    </Box>
  )
}
